export const projectStatusOptions = [
  { label: "Enviar a monitoreo", value: "AWAITING_INFO" },
  { label: "Listo para monitoreo", value: "INFO_SENT" },
  { label: "En monitoreo", value: "ON_MONITORING" },
  { label: "Liberación de monitoreo", value: "MONITORING_CONCLUDED" },
  { label: "Pagado", value: "PAID" },
  { label: "En Cierre", value: "IN_CLOSING"},
  { label: "Concluido", value: "ON_CLOSURE" }
]

export const PROJECT_MONTH_STATUS_ORDER = [
  "AWAITING_INFO",
  "INFO_SENT",
  "ON_MONITORING",
  "MONITORING_CONCLUDED",
  "PAID",
  "IN_CLOSING",
  "ON_CLOSURE"
]

export const projectStatusMap = {
  "AWAITING_INFO": "Enviar a monitoreo",
  "INFO_SENT": "Listo para monitoreo",
  "ON_MONITORING": "En monitoreo",
  "MONITORING_CONCLUDED": "Liberación de monitoreo",
  "PAID": "Pagado",
  "IN_CLOSING":"En Cierre",
  "Concluido": "ON_CLOSURE"
}
